import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarComponent } from "./components/topbar/topbar.component";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgbModalModule,
    SidebarComponent,
    TopbarComponent
],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('eletroservice-app');
  isExpanded = true;
}
